// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__4aW4s","copyright":"Footer_copyright__gJAH5","footerTel":"Footer_footerTel__E17cR"};